import React from 'react'
import styled from 'styled-components'
import LogoImage from '../../assets/images/logo/logo-full.png'
import { useNavigate } from 'react-router-dom'

const Logo = styled.img`
    height : 60px;
    cursor: pointer;
    animation : appear 1s;

    @keyframes appear {
        0%{
            opacity : 0;
        }
        100%{
            opacity : 1;
        }
    }
`
function LogoFull() {
  const navigate = useNavigate()
  return (
    <Logo src={LogoImage} alt='Peak Pashmina' onClick={()=>{navigate("/")}}/>
  )
}

export default LogoFull;